import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { TipoIniciativa } from '../../interfaces/interfaces';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Block } from 'typescript';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit, OnDestroy {
  emailUser: string;
  nombreUser: string;
  opcionSeleccionada: number;
  public listaTiposIniciativa: TipoIniciativa[] = [];
  costeo: boolean = false;
  idRolSeleccionado: number;
  private apiUrl = `${environment.UrlApiV2}Archivo/descargarFormatoAyuda`;
  private destroy$ = new Subject<void>();

  constructor(private autService: AuthService, private http: HttpClient, private dataService: DataService) {
    this.autService.user.subscribe((user: string) => {
      this.emailUser = user;
    });
    this.autService.userName.subscribe((nombre: string) => {
      this.nombreUser = nombre;
    });
  }

  ngOnInit() {
    this.autService.escuchaRolSeleccionado().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.idRolSeleccionado = res;
    });

    window.localStorage.removeItem("editarIniciativaId");
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  descargarFormatoApoyo() {
    this.descargarFormato('proyecto');
  }

  descargarFormatoApoyoConCambio() {
    this.descargarFormato('cambio_con_proceso');
  }

  descargarFormatoApoyoSinCambio() {
    this.descargarFormato('cambio_sin_proceso');
  }

  private descargarFormato(tipoIniciativa: string) {
    const idTipoIniciativa = this.obtenerIdTipoIniciativa(tipoIniciativa);
  
    if (idTipoIniciativa === null) {
      this.mostrarAlerta('Tipo de iniciativa no válido.');
      return;
    }

    /**return this.http.post(
      `${environment.urlAPI}Archivos/descargaGestor`,
      {uIdArchivo:uuid},
      {responseType:'blob'}
    ).pipe(retry(3)); */
  
    /*const payload = { id_tipoIniciativa: idTipoIniciativa };
    this.http.post(this.apiUrl, payload, { responseType: 'json' }).subscribe(
      (response: 'blob') => {
        console.log(response); // Verifica la estructura de la respuesta
        /*if (!response || !response.objData?.ruta_archivo) {
          this.mostrarAlerta('El archivo no está disponible.');
          return;
        }
        //const { ruta_archivo, nombre_archivo } = response.objData;
        //this.descargarArchivo(ruta_archivo, nombre_archivo);
      },
      error => {
        console.error('Error al descargar el archivo:', error);
        this.mostrarAlerta('No se pudo descargar el archivo. Verifica tu conexión o contacta al administrador.');
      }
    );
  }*/
    this.dataService.getDocumentoFormatoAyuda(idTipoIniciativa).subscribe({
      next: (blob) => {
        // Crear una URL para el Blob
        const url = window.URL.createObjectURL(blob);

        // Crear un enlace de descarga dinámico
        const a = document.createElement('a');
        a.href = url;
        a.download = 'archivo.pdf'; // Nombre sugerido para el archivo
        document.body.appendChild(a);

        // Simular clic para descargar
        a.click();

        // Limpiar el enlace
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        console.log('Archivo descargado con éxito');
      },
      error: (err) => {
        console.error('Error al descargar el archivo:', err);
      },
    });
  }
      
  private obtenerIdTipoIniciativa(tipoIniciativa: string): number | null {
    const mapaTiposIniciativa = {
      proyecto: 1,
      cambio_con_proceso: 2,
      cambio_sin_proceso: 3,
    };
    return mapaTiposIniciativa[tipoIniciativa] || null;
  }

  private descargarArchivo(ruta: string, nombreArchivo: string) {
    if (!ruta || !nombreArchivo) {
      this.mostrarAlerta('Información del archivo incompleta. Contacta al administrador.');
      return;
    }
  
    this.http.get(ruta, { responseType: 'blob' }).subscribe(
      (archivo: Blob) => {
        if (archivo.size === 0) {
          this.mostrarAlerta('El archivo descargado está vacío.');
          return;
        }
  
        // Verificamos si el archivo es un PDF
        if (archivo.type === 'application/pdf') {
          const fileURL = URL.createObjectURL(archivo);
          window.open(fileURL, '_blank'); // Abre el PDF en una nueva pestaña
        } else {
          // Si no es un PDF, descargamos el archivo normalmente
          const newBlob = new Blob([archivo], { type: archivo.type });
          const data = window.URL.createObjectURL(newBlob);
          const link = document.createElement('a');
          link.href = data;
          link.download = nombreArchivo; // Asigna el nombre del archivo
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
  
          setTimeout(() => {
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        }
  
        this.mostrarAlerta(`El archivo "${nombreArchivo}" ha sido descargado correctamente.`);
      },
      error => {
        console.error('Error al descargar el archivo desde la ruta:', error);
        this.mostrarAlerta('No se pudo descargar el archivo. Contacta al administrador.');
      }
    );
  }
    
  private mostrarAlerta(mensaje: string) {
    alert(mensaje);
  }

  scrollInicio() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 30); // Cuánto avanzar en cada paso
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }
}
